export enum ContractFilterStatus {
    Quote = 'Quote',
    Reservation = 'Reservation',
    Open = 'Open',
    Returned = 'Returned',
    Closed = 'Closed',
    ShowAll = 'showAll'
}
